export function getRadius(): [number, number][] {
  const centerLon = -84.694;
  const centerLat = 40.3;
  const radiusDegreesLat = 0.18; // 20km in latitude degrees (~111km per degree)
  const radiusDegreesLon = 0.235; // 20km in longitude degrees at this latitude (~85km per degree)
  const points = 64;
  const coordinates: [number, number][] = [];

  for (let i = 0; i <= points; i++) {
    const angle = (i / points) * 2 * Math.PI;
    const x = centerLon + radiusDegreesLon * Math.cos(angle);
    const y = centerLat + radiusDegreesLat * Math.sin(angle);
    coordinates.push([x, y]);
  }

  return coordinates;
}
